<template>
  <div class="body">
    <!-- 计划详情 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <h2>课程信息</h2>
      </div>
      <div class="plan-detail">
        <el-row>
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <span class="span-left">课程名称: </span>
            <span>{{ programDetail.trainingName }}
              <!-- 0未下达 1进行中 2已下达 -->
            <span v-if="programDetail.isMallImport != 1 && programDetail.sourceId">【课程来源：平台分配】</span>
            <span v-if="programDetail.isMallImport!=1 && !programDetail.sourceId">【课程来源：企业制作】</span>
            <span v-if="programDetail.isMallImport == 1">【课程来源：商城】</span>
              </span>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                来源：
                <span v-if="config.includeMall">  商城：从商城加入课程,根据课程设置的价格进行收费;</span>
                上传：企业自己上传课件；
                平台分配：由平台分发给企业的课件</div>
              <i class="el-icon-question"></i>
              <i class="el-icon-question"></i>
            </el-tooltip>

          </el-col>
        </el-row>

        <el-row >
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <span class="span-left">培训分类: </span>
            <span>{{ programDetail.trainingCategoryName }}</span>
          </el-col>
        </el-row>
        <el-row v-if="config.includeMall && !config.freeCourse">
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <el-col :span="4">
              <span class="span-left">课程价格: </span>
            </el-col>
            <el-col :span="20">
              <span v-if="programDetail.free == 1">限时免费</span>
              <template v-else-if="programDetail.isMallImport == 1 || (programDetail.isMallImport != 1 && programDetail.sourceId)">
                <span >{{ programDetail.totalsPrice }} ¥</span>
                <p>说明：该价格为所有课件总和价格，安排给员工后将会在员工点击课件进行观看时进行扣费。请保证企业余额充足</p>
              </template>
              <span v-else>0 ¥</span>
            </el-col>


          </el-col>
        </el-row>

        <!--        <el-row>-->
        <!--          <el-col :span="12" style="border-bottom:1px solid #99999950;">-->
        <!--            <span class="span-left">地点:</span>-->
        <!--            <span>{{ programDetail.location }}</span>-->
        <!--          </el-col>-->
        <!--          <el-col :span="12" style="border-bottom:1px solid #99999950;">-->
        <!--            <span class="span-left">附件列表:</span>-->
        <!--            <span-->
        <!--              v-for="item in programDetail.annexList"-->
        <!--              style="padding-right:20px;"-->
        <!--            >{{ item }}</span-->
        <!--            >-->
        <!--          </el-col>-->
        <!--        </el-row>-->

        <el-row>
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <el-col :span="4">
              <span class="span-left">章节编排: </span>
            </el-col>
            <el-col :span="2">
              <chapterLayout @check-change="handleCheckChange" :checkedKeys="checkResourcesDataIds" :trainingProgramId="$route.query.id"
                             style="margin-top: 30px; display: inline-block"></chapterLayout>
            </el-col>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <el-col :span="4">
              <span class="span-left">是否签到: </span>
            </el-col>
            <el-col :span="20">
              <el-radio-group v-model="enableSign">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
              <p>开启签到后，学员培训前需要进行电子手签。并会记录到《学员名册及考勤表》档案中。</p>
            </el-col>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <el-col :span="4">
              <span class="span-left">防挂机验证: </span>
            </el-col>
            <el-col :span="20">
              <el-radio-group v-model="enableVerification">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
              <p>开启防挂机验证后员工学习过程中会进行人脸识别，确保是员工本人在培训</p>
            </el-col>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <el-col :span="4">
              <span class="span-left">是否问卷调查: </span>
            </el-col>
            <el-col :span="20">
              <el-radio-group v-model="isQuestionnaire">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
              <p>开启问卷调查后,学员学完课程后会被随机抽取进行调查评问卷的填写，结果会记录在《综合考评报告》档案中。 </p>
            </el-col>
          </el-col>
        </el-row>

        <el-row v-if="isQuestionnaire">
          <el-col :span="24" style="border-bottom:1px solid #99999950;">
            <el-col :span="4">
              <span class="span-left">问卷抽查人数: </span>
            </el-col>
            <el-col :span="20">
              <el-input-number  controls-position="right" size="small" v-model="questionnaireTotal"  :min="1" label="问卷抽查人数" style="top: 15px"></el-input-number>
            </el-col>
          </el-col>
        </el-row>

      </div>
    </el-card>
    <!-- 任务详情 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix f-b-c">
        <h2>任务详情</h2>
        <!--        <el-button type="primary" @click="addTask">添加任务</el-button>-->
      </div>

      <div class="trainDetail">
        <!-- 培训任务1 -->
        <div class="mb30" v-for="(item, index) in taskList" :key="index">
          <!--          <h3 class="mb20">培训任务{{ index + 1 }}</h3>-->
          <el-form
            :model="item.form"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="6">
                <el-form-item label="任务名称" prop="taskName">
                  <el-input
                    placeholder="请输入"
                    v-model="item.form.taskName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!--              <el-col :span="6">-->
              <!--                <el-form-item label="培训类型" prop="type">-->
              <!--                  <el-select v-model="item.form.type" placeholder="请选择">-->
              <!--                    <el-option-->
              <!--                      v-for="(item, index) in trainingTaskTypeOptions"-->
              <!--                      :key="index"-->
              <!--                      :label="item.text"-->
              <!--                      :value="item.code"-->
              <!--                    ></el-option>-->
              <!--                  </el-select>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->

              <el-col :span="12">
                <el-form-item label="培训时间" prop="date">

                  <el-date-picker
                    v-model="item.form.date"
                    :picker-options="pickerOption"
                    :editable="false"
                    :clearable="false"
                    value-format="timestamp"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="getTrainingTime(item.form.date)"
                  ></el-date-picker>

                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="关联计划" prop="safetyTrainingProgramId">
                  <el-select v-model="item.form.safetyTrainingProgramId" placeholder="选择关联计划">
                    <el-option
                      v-for="(item, index) in safetyTrainingProgramOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <el-table :data="item.personList" style="width: 100%" class="mb20" height="356">
            <el-table-column label="序号">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="label" label="培训人员"></el-table-column>
            <!-- <el-table-column label="对象类型"></el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="delTableTask(index, scope.$index)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="f-b-c">
            <div>
              <el-button type="primary" @click="addPerson(index)"
              >添加培训人员
              </el-button
              >
              <el-button type="danger" v-if="index > 0" @click="delTask(index)"
              >删除任务
              </el-button
              >
            </div>
            <el-button type="primary" @click="setExam(index)"
            >点击设置考试
            </el-button
            >
          </div>
        </div>
      </div>

      <div class="searchBut" style="margin-top: 15px;  text-align: center">
        <el-button type="primary" :loading="saveLoading" @click="planToIssue">下发计划</el-button>
        <el-button @click="$router.go(-1)">取消</el-button>
      </div>
    </el-card>

    <!-- 选择培训人员弹窗 -->
    <el-dialog title="选择用户" :visible.sync="isShowSelectPerson" width="70%">
      <div class="f-c">
        <div style="heigth:100%;margin-right:100px;">
          <div class="mb10">
            <el-radio v-model="userSelection" label="0">用户</el-radio>
            <el-radio v-model="userSelection" label="1">部门</el-radio>
            <el-radio v-model="userSelection" label="2">岗位</el-radio>
            <el-radio v-model="userSelection" label="3">角色</el-radio>
          </div>

          <el-tree
            v-show="userSelection == 0"
            :props="props"
            :data="deptTree"
            show-checkbox
            @check-change="treeChange1"
          ></el-tree>
          <el-tree
            v-show="userSelection == 1"
            :props="props"
            :data="deptTree"
            show-checkbox
            @check-change="treeChange2"
          ></el-tree>
          <div v-show="userSelection == 3">
            <el-checkbox-group v-model="selectRoleList">
              <div v-for="(item,index) in roleList" :key="index">
                <el-checkbox :label="index">{{ item.roleName }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>

        </div>

        <el-transfer
          v-show="userSelection == 0"
          :titles="['未选择', '已选择']"
          :data="transferData1"
          v-model="transferModel1"
        ></el-transfer>
        <el-transfer
          v-show="userSelection == 1"
          :titles="['未选择', '已选择']"
          :data="transferData2"
          v-model="transferModel2"
        ></el-transfer>
        <el-transfer
          v-show="userSelection == 3"
          :titles="['未选择', '已选择']"
          :data="transferData4"
          v-model="transferModel4"
        ></el-transfer>
      </div>

      <span slot="footer">
        <el-button @click="isShowSelectPerson = false">取 消</el-button>
        <el-button type="primary" @click="selectPersonComfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设置考试弹窗 -->
    <el-dialog title="设置考试" :visible.sync="isShowSetExam" width="70%">
      <el-form
        ref="examForm"
        :rules="examRule"
        label-width="100px"
        :model="examForm"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="考试名称" prop="examName">
              <el-input
                v-model="examForm.examName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考试时间" prop="date">
              <el-date-picker
                v-model="examForm.date"
                :picker-options="pickerOption"

                type="datetimerange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="getExaminationTime(examForm.date)"
              ></el-date-picker>



            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="考试类型">
              <el-input disabled placeholder="培训关联考试"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="考试时长" prop="examDuration">

              <el-input
                type="number"
                disabled
                v-if="examForm.examDuration &&  examForm.examDuration > 0"
                v-model="examForm.examDuration"
                placeholder="请输入考试时长（分钟）"
              ></el-input>
              <el-input
              v-else
              disabled
              :value="'不限制'"
            ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="考试地点" prop="examLocation">
              <el-input
                disabled
                v-model="examForm.examLocation"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="总分数" prop="fraction">
              <el-input
                type="number"
                disabled
                v-model="examForm.fraction"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="合格分数" prop="passingScore">
              <el-input
                disabled
                v-model="examForm.passingScore"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="考试次数" prop="examFrequency">
              <el-input
                type="number"
                v-model="examForm.examFrequency"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="是否需要签到" prop="isSignin">
              <el-switch v-model="examForm.isSignin"></el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="打乱题序" prop="upsetQuestions">
              <el-switch v-model="examForm.upsetQuestions"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <h3 class="body-title">试卷详情</h3>
      <el-table :data="paperList" style="width: 100%"  height="460">
        <el-table-column label="请选择">
          <template slot-scope="scope">
            <el-radio v-model="selectPaperIndex" :label="scope.$index"
            >选择试卷
            </el-radio
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="questionsPaperName"
          label="试卷名称"

        ></el-table-column>
        <el-table-column label="试卷类型">
          <template slot-scope="scope">{{
              scope.row.selectionMode == 0 ? "随机试题" : "固定试题"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="department" label="所属部门"></el-table-column>
        <el-table-column
          prop="questionNumber"
          label="包含题目数量"
        ></el-table-column>
      </el-table>

      <!-- <h3 class="body-title">考试人员</h3>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="date" label="试卷名称"></el-table-column>
        <el-table-column prop="date" label="试卷类型"></el-table-column>
        <el-table-column prop="date" label="所属部门"></el-table-column>
        <el-table-column prop="date" label="包含题目数量"></el-table-column>
      </el-table>-->
      <span slot="footer">
        <el-button @click="isShowSetExam = false">取 消</el-button>
        <el-button type="primary" @click="setExamComfirm">确 定</el-button>
      </span>
    </el-dialog>

    <userSelection ref="userSelection" @submit="selectPersonComfirm"></userSelection>

  </div>
</template>

<script>
import api from "../../../api/new/training.js";
import safetyRainingProgramApi from "@/api/new/safety_raining_program.js";
import DIC_API from '../../../api/api_dictionary';

import api_user from "@/api/api_user.js";
import api_role from "@/api/api_role.js";
import exam from "@/api/new/exam.js";
import chapterLayout from '@/pages/trainingManagement/component/chapterLayout.vue';

import userSelection from '@/pages/trainingManagement/component/user/userSelection.vue';
import config from '@/config/config.js'
export default {
  components: {chapterLayout, userSelection},
  data() {
    return {
      config:config,
      enableSign: 1, //是否签到
      enableVerification: 0, //是否开启验证功能
      isQuestionnaire: false, //是否问卷调查
      questionnaireTotal: 1, // 问卷抽查人数

      isShowSelectPerson: false, // 选择培训人员弹窗
      isShowSetExam: false, // 设置考试弹窗
      deptTree: [],
      selectPaperIndex: 0, //
      programDetail: {},
      transferData1: [], // 穿梭框左边边的数据
      transferModel1: [], // 穿梭框右边的数据
      transferData2: [], // 穿梭框左边边的数据
      transferModel2: [], // 穿梭框右边的数据
      transferData3: [], // 穿梭框左边边的数据
      transferModel3: [], // 穿梭框右边的数据
      transferData4: [], // 穿梭框左边边的数据
      transferModel4: [], // 穿梭框右边的数据
      trainingTaskTypeOptions: [],
      safetyTrainingProgramOptions: [],
      props: {
        label: "text",
        children: "children"
      },
      userSelection: "0",
      selectTaskIndex: 0,
      taskList: [
        {
          form: {
            taskName: "", //任务名称
            trainer: "", //培训讲师
            trainerCondition: "",
            trainingStartTimeLong: "",
            trainingEndTimeLong: "",
            type: '',  // 培训类型
            safetyTrainingProgramId: '',
            date:''
          },
          personList: [],
          trainingExamDetailLists: {
            paperId: undefined,
            paperName: undefined,
            paperType: undefined,
            examName: undefined,
            examType: "PXGL",
            examTypeString: "培训关联考试",
            fraction: undefined,
            examDuration: undefined,
            examLocation: undefined,
            passingScore: undefined,
            examFrequency: undefined,
            // actualScore: undefined,
            isSignin: undefined,
            upsetQuestions: undefined,
            department: "所属部门",
            questionsNumber: undefined,
            startTimeLong: undefined,
            endTimeLong: undefined
          },
          personType: 0 // 0:用户,1:部门,2:岗位,3:角色
        }
      ], //任务列表

      examForm: {
        paperId: undefined,
        paperName: undefined,
        paperType: undefined,
        examName: undefined,
        examType: 'PXGL',
        examTypeString: "培训关联考试",
        fraction: undefined,
        examDuration: undefined,
        examLocation: '线上考试',
        passingScore: undefined,
        examFrequency: 1,
        // actualScore: undefined,
        isSignin: false,
        upsetQuestions: false,
        department: "所属部门",
        questionsNumber: undefined,
        startTimeLong: undefined,
        endTimeLong: undefined,
        date: []
      },
      rules: {
        date: [{required: true, message: "请选择任务起止时间", trigger: "blur"}],
        taskName: [{required: true, message: "请输入任务名称", trigger: "blur"}]
      },
      examRule: {
        examLocation: [{required: true, message: "请输入考试地点", trigger: "blur"}],
        date: [{required: true, message: "请选择考试时间", trigger: "blur"}],
        paperName: [{required: true, message: "请输入", trigger: "blur"}],
        paperType: [{required: true, message: "请输入", trigger: "blur"}],
        examName: [{required: true, message: "请输入考试名称", trigger: "blur"}],
        examType: [{required: true, message: "请输入", trigger: "blur"}],
        fraction: [{required: true, message: "请输入", trigger: "blur"}],
        examDuration: [{required: true, message: "请输入", trigger: "blur"}],
        passingScore: [{required: true, message: "请输入", trigger: "blur"}],
        examFrequency: [{required: true, message: "请输入", trigger: "blur"}],
        department: [{required: true, message: "请输入", trigger: "blur"}],
        questionsNumber: [
          {required: true, message: "请输入", trigger: "blur"}
        ]
      },
      userSelectDept: [], // 用户栏选择的部门
      paperList: [],
      roleList: [],
      selectRoleList: [],

      saveLoading: false,

      // check resources data id array
      checkResourcesDataIds: [],
      // 控制时间选择范围，限制只能选择 今天以及以后的时间
      pickerOption: {
        disabledDate(time) {
          let cdate =  new Date();
          if (time.getFullYear() < cdate.getFullYear() ) {
            return true;
          }
          if (time.getFullYear() == cdate.getFullYear() && time.getMonth() < cdate.getMonth()){
            return true;
          }
          if ( time.getFullYear() == cdate.getFullYear() && time.getMonth() == cdate.getMonth() && time.getDate() <  cdate.getDate()){
            return true;
          }
          return false;
        }
      }
    };
  },
  mounted() {
    //获取培训类型
    DIC_API.getListByParentCode({
      parentCode: 'training_task_type'
    }).then((result) => {
      if (result && result.length > 0) {
        this.trainingTaskTypeOptions = result;
      }
    });
    this.deptTree = JSON.parse(localStorage.getItem("deptTree"));
    this.getProgramDetail();
    this.getRole();
  },
  methods: {
    getExaminationTime(val){
      if(val[0] === val[1]){
        this.$message({
          message: '考试开始时间与考试结束时间不能相同！',
          type: 'warning'
        });
      }
    },
    getTrainingTime(val){
      if(val[0] === val[1]){
        this.$message({
          message: '开始时间与结束时间不能相同！',
          type: 'warning'
        });
      }
    },
    handleCheckChange(data){
      console.log('handleCheckChange -- %o', data);
      this.checkResourcesDataIds = data.checkedKeys;
    },
    getRole() {
      api_role.findList({
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,
      }).then(res => {
        this.roleList = res.rows;
      })
    },
    getPaperList() {
      exam
        .getPaperList({
          programId: this.programDetail.id
        })
        .then(res => {
          this.paperList = res.data.records;
        });
    },
    getProgramDetail() {
      api.getProgramDetail({programId: this.$route.query.id}).then(res => {
        this.programDetail = res.data;
        this.taskList[0].form.taskName=this.programDetail.trainingName


        this.getPaperList();
        this.loadSafetyTrainingProgramOptions();
      });
    },
    delTableTask(i1, i2) {
      this.taskList[i1].personList.splice(i2, 1);
    },
    selectPersonComfirm(a) {
      console.log(a)
      this.$set(this.taskList[this.selectTaskIndex], "personList", a);
    },
    setExamComfirm() {
      this.$refs.examForm.validate(validate => {
        if (validate){
          this.examForm.paperId = this.paperList[this.selectPaperIndex].id;
          this.examForm.paperName = this.paperList[
            this.selectPaperIndex
            ].questionsPaperName;
          if (this.examForm.isSignin){

          }
          this.examForm.isSignin = this.examForm.isSignin ? true : false;
          this.examForm.upsetQuestions = this.examForm.upsetQuestions ? true : false;
          this.examForm.paperType = this.paperList[
            this.selectPaperIndex
            ].selectionMode;
          this.examForm.questionsNumber = this.paperList[
            this.selectPaperIndex
            ].questionNumber;

          this.examForm.paperType = this.paperList[
            this.selectPaperIndex
            ].selectionMode;
          this.examForm.paperId = this.paperList[this.selectPaperIndex].id;

          // if (!this.examForm.date || this.examForm.date.length == 0)
            //return this.$message.error("请选择时间");

          this.examForm.startTimeLong = this.examForm.date[0];
          this.examForm.endTimeLong = this.examForm.date[1];
          // delete this.examForm.date;

          if(this.examForm.date[0] === this.examForm.date[1] ){
            this.$message({
              message: '考试开始时间与考试结束时间不能相同！',
              type: 'warning'
            });
            throw "error";
          }
          // console.log(this.examForm);
          //if (validate == false) return this.$message.error("请填写表单");

          this.taskList[
            this.selectTaskIndex
            ].trainingExamDetailLists = this.examForm;
          this.isShowSetExam = false;

          console.log(this.taskList);
        }else {
          return false;
        }
      });
    },
    treeChange1(data, isSelect) {
      console.log(arguments);
      api_user
        .listNopagging({
          deptId: data.id
        })
        .then(res => {
          if (isSelect) {
            res.forEach(person => {
              this.transferData1.push({
                key: person.id,
                label: person.userName
              });
            });
          } else {
            res.forEach((v, i) => {
              this.transferData1.forEach((v2, i2) => {
                if (v.id == v2.key) this.transferData1.splice(v2, 1);
              });
            });
          }
        });
    },
    treeChange2(data, isSelect) {
      if (isSelect) {
        this.transferData2.push({
          key: data.id,
          label: data.text
        });
      } else {
        this.transferData2.forEach((v, i) => {
          if (v.key == data.id) {
            this.transferData2.splice(i, 1);
          }
        });
      }
    },
    addTask() {
      this.taskList.push({
        form: {},
        personList: []
      });
    },
    delTask(index) {
      this.taskList.splice(index, 1);
    },
    addPerson(index) {
      this.selectTaskIndex = index;
      console.log(this.taskList[this.selectTaskIndex].personList)

      console.log(this.taskList[this.selectTaskIndex].personList)
      this.$refs.userSelection.show(this.taskList[this.selectTaskIndex].personList);
    },
    setExam(index) {
      this.selectTaskIndex = index;
      this.isShowSetExam = true;
      this.autoSetExamForm();
    },
    autoSetExamForm() {
      if (this.paperList.length === 0) return;
      this.examForm.examDuration = this.paperList[
        this.selectPaperIndex
        ].examTime;
      this.examForm.fraction = this.paperList[this.selectPaperIndex].fraction;
      this.examForm.passingScore = this.paperList[
        this.selectPaperIndex
        ].gradesThroughRegulation;

      console.log(this.examForm);
    },
    planToIssue() {
      if (this.checkResourcesDataIds.length < 1){
        this.$message.error("请选择培训章节");
        throw "error";
      }

      let p = [];
      this.taskList.forEach(v => {
        if (!v.form.taskName) {
          this.$message.error("请输入任务名称");
          throw "error";
        }
        if (!v.form.date) {
          this.$message.error("请选择培训时间");
          throw "error";
        }
        if (v.personList.length == 0) {
          this.$message.error("请添加培训人员");
          throw "error";
        }
        if(v.form.date[0]==v.form.date[1]){
          this.$message({
            message: '培训开始时间与培训结束时间不能相同！',
            type: 'warning'
          });
          throw "error";
        }
        let temp = {
          trainingProgramId: this.$route.query.id,
          taskName: v.form.taskName,
          trainer: v.form.trainer,
          trainerCondition: v.form.trainerCondition,
          type: v.form.type,
          safetyTrainingProgramId: v.form.safetyTrainingProgramId,
          trainingStartTimeLong: v.form.date[0],
          trainingEndTimeLong: v.form.date[1],
          trainingTaskJoinUserDtos: [],
          enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,
          resourcesDataIds: this.checkResourcesDataIds,
          enableSign: this.enableSign,
          enableVerification: this.enableVerification
        };

        if (this.isQuestionnaire) {
          temp.questionnaireTotal = this.questionnaireTotal;
        } else {
          temp.questionnaireTotal = 0;
        }


        let isAllTrue = true;
        for (let k in v.trainingExamDetailLists) {
          if (
            v.trainingExamDetailLists[k] == undefined ||
            v.trainingExamDetailLists[k] == null
          ) {
            isAllTrue = false;
          }
        }
        if (isAllTrue) temp.trainingExamDetailLists = v.trainingExamDetailLists;
        if (temp.trainingExamDetailLists) {
          temp.trainingExamDetailLists.enterpriseId = JSON.parse(localStorage.getItem("userinfo")).enterpriseId;
          temp.trainingExamDetailLists.isSignin =  temp.trainingExamDetailLists.isSignin? 0: 1;
          temp.trainingExamDetailLists.upsetQuestions =  temp.trainingExamDetailLists.upsetQuestions? 0: 1;
          delete temp.trainingExamDetailLists.date;
        }
        v.personList.forEach(v2 => {
          temp.trainingTaskJoinUserDtos.push({
            busiId: v2.key,
            busiName: v2.label,
            busiType: v2.personType
          });
        });
        p.push(temp);
      });
      console.log(p)
      this.saveLoading = true;
      if (this.programDetail.sourceId || this.programDetail.free) {
        this.apiPlanToIssue(p);
      } else {
        api.calculateCost(p).then(res =>{
          console.log(res)
          if (res.code == 0) {
            if (res.data.totalPrice <= 0) {
              this.apiPlanToIssue(p);
              return ;
            }
            this.$confirm('下发课程消费：'+res.data.totalPrice+' 元 ,是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.apiPlanToIssue(p);
            }).catch(() => {
              this.saveLoading = false;
            });
          }

        })
      }
    },
    apiPlanToIssue(p){
      api.planToIssue(p).then(res => {
        if (res.code == 0) {
          this.$message.success("计划下发成功");
          this.$router.go(-1);
        } else {
          this.saveLoading = false;
          this.$message.error(res.message);
        }
      });
    },
    loadSafetyTrainingProgramOptions() {
      if (this.programDetail.trainingLevelIds && this.programDetail.trainingLevelIds.length > 0) {
        let params = {
          trainingLevelId: this.programDetail.trainingLevelIds[0],
          method: 1
        }
        safetyRainingProgramApi.options(params).then(res => {
          if (res.code == 0) {
            this.safetyTrainingProgramOptions = res.data;
            console.log('loadSafetyTrainingProgramOptions: %o', this.safetyTrainingProgramOptions)
          } else {
            this.$message.error(res.message);
          }
        });
      }
    }
  },
  watch: {
    selectPaperIndex() {
      this.autoSetExamForm();
    },
    selectRoleList(v) {
      let arr = [];
      v.forEach(item => {
        arr.push({
          key: this.roleList[item].id,
          label: this.roleList[item].roleName,
        });
      })
      this.transferData4 = arr;
    }
  }
};
</script>

<style>
.el-form-item__label {
  white-space: nowrap;
}

.required {
  color: red;
}

.hr {
  height: 2px;
  background: #e4e4e4;
  flex: 1;
  margin-left: 20px;
}

.trainDetail {
  padding: 20px;
}

.plan-detail span {
  font-size: 14px;
  line-height: 50px;
  display: inline-block;
}

.span-left {
  padding-left: 30px;
  margin-right: 10px;
  width: 120px;
  text-align: right;
}

.box-card {
  margin-bottom: 20px;
}


/*.el-col-4 {*/

/*  width: 13%;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/task/publishTask.vue